import { render, staticRenderFns } from "./ChallengeItemStats.vue?vue&type=template&id=dc6ae894&scoped=true"
import script from "./ChallengeItemStats.vue?vue&type=script&lang=ts"
export * from "./ChallengeItemStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6ae894",
  null
  
)

export default component.exports